export type SyncTarget = 'web-view' | 'desktop-app';

export const syncTargets = ['web-view', 'desktop-app'] as const;
